export interface Context {
  experiment_active: string;
  group_name: string;
  experiment_name: string;
  customer_user_id?: string;
  logged_in: number | undefined;
  paid: number | undefined;
  layer: string;
  environment?: string;
  experiments?: Record<string, { variant_id: string; type: string }>
}

export enum Environment {
  DEVELOPMENT = "development",
  PRODUCTION = "production",
  STAGING = "staging",
}
